import ChangePassword from "./changepassword";

export default ChangePassword;
